export enum ActivityLogAction {
  CreatedUser = 'Created User',
  UpdatedUser = 'Updated User',
  DeletedUser = 'Deleted User',
  Login = 'Login',
  PasswordRecovery = 'Password Recovery',
  PasswordChange = 'Password Change',
}

export type ActivityLog = {
  id: string;
  userId: string;
  action: ActivityLogAction;
  context: Record<string, unknown>;
  timestamp: Date;
};
